import { FormControl, FormLabel, RadioGroup, FormHelperText, RadioGroupProps } from "@mui/material";
import { useFormikContext } from "formik";
import { FC } from "react";

export type RadioGroupFieldProps = RadioGroupProps & {
  label: string;
  name: string;
}

const RadioGroupField: FC<RadioGroupFieldProps> = ({
  label,
  name,
  ...rest
}) => {
  const {
    touched,
    errors,
    values,
    handleBlur,
    handleChange
  } = useFormikContext<any>()
  
  return (
    <FormControl component="fieldset" error={Boolean(touched[name] && errors[name])}>
      <FormLabel component="legend">{label}</FormLabel>
      <RadioGroup
        name={name}
        onBlur={handleBlur}
        onChange={handleChange}
        value={values[name]}
        {...rest}
      />
      {Boolean(touched[name] && errors[name]) && <FormHelperText>{touched[name] && errors[name]}</FormHelperText>}
    </FormControl>
  )
}

export default RadioGroupField;

